module.exports = __webpack_public_path__ + "static/b2-cd266329aea33b14a8cf51e797d219d8.jpg";